// extracted by css-extract-rspack-plugin
export default {"cls1":"UpsellModalRedesign-cls1_akf","cls2":"UpsellModalRedesign-cls2_2Ag UpsellModalRedesign-cls1_akf","primary":"UpsellModalRedesign-primary_ri1"};